<form
  class="form-inline search-full"
  [class.open]="navServices.search"
  (submit)="searchTerm(text)"
>
  <div class="form-group w-100">
    <app-feather-icons
      [icon]="'search'"
      class="close-search"
      (click)="searchTerm(text)"
      style="right: 60px"
    >
    </app-feather-icons>
    <input
      class="form-control-plaintext"
      [(ngModel)]="text"
      [ngModelOptions]="{ standalone: true }"
      type="text"
      autocomplete="on"
      placeholder="{{ textSearch }}"
    />
    <!-- placeholder="{{'Search'|translate}}" -->
    <!-- (keyup.enter)="searchTerm(text)" -->
    <app-feather-icons
      [icon]="'x'"
      class="close-search"
      (click)="searchToggle()"
    ></app-feather-icons>

    <div
      class="Typeahead-menu"
      [class.is-open]="searchResult"
      *ngIf="products?.length"
      id="search-outer"
    >
      <div
        class="ProfileCard u-cf"
        *ngFor="let menuItem of products | slice: 0:8"
      >
        <!-- <div
        class="ProfileCard u-cf"
        *ngFor="let menuItem of products | slice: 0:8"
      > -->
        <div class="ProfileCard-avatar">
          <img
            src="{{ menuItem?.Articulo.ImagenesArticulo[0].Imagen }}"
            style="width: 25px"
          />
        </div>
        <div class="ProfileCard-details">
          <div class="ProfileCard-realName">
            <a
              href="javascript:void(0)"
              class="realname"
              (click)="QuickView.openModal(menuItem)"
            >
              <!-- <a href="javascript:void(0)" class="realname" [routerLink]="['/productos', menuItem.Articulo.Codigo]"> -->
              {{ menuItem?.Articulo.Nombre }}</a
            >
          </div>
        </div>
      </div>
      <!-- SC CATWEB-396 Solo si la cantidad de articulos de la busqueda es mayor a 8 se agrega el link de ver n resultados para testo. -->
      <!-- SC CATWEB-396 se agrega el parametro search al path de productos, con el texto ingresado. -->
      <ng-container *ngIf="totalItems > 8">
        <a
          class="text-center"
          routerLink="/productos"
          [queryParams]="{ search: text }"
          (click)="irProductos()"
        >
          Ver {{ totalItems }} resultados para {{ text }}</a
        >
      </ng-container>
    </div>
    <div class="Typeahead-menu" [class.is-open]="searchResultEmpty">
      <div class="tt-dataset tt-dataset-0">
        <div class="EmptyMessage">Resultado de la búsqueda.</div>
      </div>
    </div>
  </div>
</form>

<app-product-view
  [muestraFinal]="muestraFinal"
  [muestraNeto]="muestraNeto"
  [muestraLista]="muestraLista"
  [mostrarPrecio]="verPrecios"
  #quickView
></app-product-view>
